// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/navigation/Footer.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/navigation/Footer.tsx");
  import.meta.hot.lastModified = "1732036225883.7432";
}
// REMIX HMR END

import Logo from "@assets/logo/logo.png";
import Link from "~/components/Link";
import IconResolver from "~/components/IconResolver";
import ContentWrapper from "~/components/ContentWrapper";
const SOCIAL_LINKS = [{
  title: "Twitter",
  url: "https://twitter.com/OctahedroidHQ",
  iconToken: "twitter"
}, {
  title: "GitHub",
  url: "https://github.com/octahedroid",
  iconToken: "github"
}, {
  title: "LinkedIn",
  url: "https://www.linkedin.com/company/octahedroid",
  iconToken: "linkedin"
}, {
  title: "Facebook",
  url: "https://www.facebook.com/octahedroidHQ",
  iconToken: "facebook"
}, {
  title: "Instagram",
  url: "https://www.instagram.com/octahedroid",
  iconToken: "instagram"
}];
export default function Footer({
  navigation = []
}) {
  return <ContentWrapper Item="footer" spacing="primary" className="bg-gradient-tertiary border-neutral-300 shrink-0 mt-auto">
      <div className="w-full">
        <img src={Logo} alt="Octahedroid" className="w-[155px] mx-auto mb-4" />
        <nav className="flex flex-col md:flex-row items-center justify-center md:mb-4">
          <ul className="flex divide-x items-center divide-neutral-100 md:mr-6 mb-4 md:mb-0">
            {navigation.map(({
            route,
            title
          }) => <li className="first:pl-0 last:pr-0 px-2" key={title}>
                <Link theme="dark" to={route.url} underline>
                  {title}
                </Link>
              </li>)}
          </ul>
          <ul className="flex justify-center gap-3 mb-4 md:mb-0">
            {SOCIAL_LINKS.map(({
            title,
            url,
            iconToken
          }) => <li key={title}>
                <Link target="_blank" rel="noopener noreferrer" to={url} theme="dark">
                  <span className="sr-only">{title}</span>
                  <IconResolver className="w-[18px] aspect-square" token={iconToken} />
                </Link>
              </li>)}
          </ul>
        </nav>
        <p className="text-sm text-neutral-100 text-center mb-4 md:mb-0">
          Copyright © {new Date().getFullYear()} Octahedroid. All rights
          reserved.
        </p>
      </div>
    </ContentWrapper>;
}
_c = Footer;
var _c;
$RefreshReg$(_c, "Footer");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;